import { apiClient } from './apiClient';
import { Logger } from '../utils/logger';

export const dataService = {
  checkHealth: async () => {
    try {
      // Health check is at root /health, not /api/v1/health
      // We need to bypass the baseURL of apiClient
      const baseURL = apiClient.defaults.baseURL || '';
      const rootURL = baseURL.replace('/api/v1', '');
      const response = await fetch(`${rootURL}/health`);
      
      if (response.ok) {
        const data = await response.json();
        return { ok: true, ...data };
      }
      return { ok: false };
    } catch (error) {
      // WARN et pas ERROR : le seul appelant (`useRaisoData.refreshData`) traite déjà
      // `{ ok: false }` comme un repli attendu — il logge « using mock data » et sort sans
      // erreur. Logger ici en ERROR produisait donc un double-log ET une sévérité fausse.
      //
      // Cas réel le plus fréquent : le fetch est avorté par une navigation qui arrive pendant
      // le vol (rechargement, changement de route) → `TypeError: Failed to fetch`. Ce n'est pas
      // un incident : c'est le navigateur qui annule. La requête réseau correspondante est déjà
      // reconnue comme non significative côté E2E (`net::ERR_ABORTED`,
      // V4-E2E-RELOAD-ABORTS-FALSE-POSITIVE) ; la console suivait la même logique en retard.
      //
      // WARN reste émis en production (cf. `utils/logger.ts`), donc aucune perte de visibilité
      // sur un backend réellement injoignable (V4-FRONT-HEALTHCHECK-DOUBLE-LOG, 2026-07-30).
      Logger.warn('Health check failed:', error);
      return { ok: false };
    }
  },

};
